import {createReducer} from '@reduxjs/toolkit';

import {
    getCompanyByIdFailure,
    getCompanyByIdRequest,
    getCompanyByIdSuccess,
    searchCompaniesFailure,
    searchCompaniesRequest,
    searchCompaniesSuccess,
} from '/src/openapi/ccdb-bff/apis/CompaniesApi';
import {CcdbCompany} from '/src/openapi/ccdb-bff/models/CcdbCompany';
import {CompanySearchResponse} from '/src/openapi/ccdb-bff/models/CompanySearchResponse';

export type CompanySearchState = {
    searchResults: CompanySearchResponse | null,
    selectedCompany: CcdbCompany | null,
    loading: boolean,
    detailLoading: boolean,
    error: string | null,
};

const initialState: CompanySearchState = {
    searchResults: null,
    selectedCompany: null,
    loading: false,
    detailLoading: false,
    error: null,
};

export const ccdbCompanySearch = createReducer<CompanySearchState>(initialState, builder => builder
    .addCase(searchCompaniesRequest, state => {
        state.loading = true;
        state.error = null;
    })
    .addCase(searchCompaniesSuccess, (state, action) => {
        state.searchResults = action.payload.data;
        state.loading = false;
        state.error = null;
    })
    .addCase(searchCompaniesFailure, (state, action) => {
        state.loading = false;
        state.error = action.payload.data?.message || 'Search failed';
    })
    .addCase(getCompanyByIdRequest, state => {
        state.detailLoading = true;
        state.error = null;
    })
    .addCase(getCompanyByIdSuccess, (state, action) => {
        state.selectedCompany = action.payload.data;
        state.detailLoading = false;
        state.error = null;
    })
    .addCase(getCompanyByIdFailure, (state, action) => {
        state.detailLoading = false;
        state.error = action.payload.data?.message || 'Failed to load company';
    }),
);
